import { render, staticRenderFns } from "./Servicios2025.vue?vue&type=template&id=fcaee93e&scoped=true"
import script from "./Servicios2025.vue?vue&type=script&lang=js"
export * from "./Servicios2025.vue?vue&type=script&lang=js"
import style0 from "./Servicios2025.vue?vue&type=style&index=0&id=fcaee93e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcaee93e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/github/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fcaee93e')) {
      api.createRecord('fcaee93e', component.options)
    } else {
      api.reload('fcaee93e', component.options)
    }
    module.hot.accept("./Servicios2025.vue?vue&type=template&id=fcaee93e&scoped=true", function () {
      api.rerender('fcaee93e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/landingPage/Servicios2025.vue"
export default component.exports